var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { convertDateToYearMonth, converYearMonthToString, getKanban, } from '../../services/dashboard';
import { Loader } from '../../utils/Loader';
import { classTotal, colorEtatActivite, colorEtatAffaire, } from '../../utils/Classes';
import { ActiviteIcon, AffaireIcon, ClientIcon, KanbanIcon, } from '../../utils/Icons';
import { Autocomplete, Card, FormControlLabel, Grid, Radio, RadioGroup, Stack, TextField, } from '@mui/material';
import { Typography } from '../../utils/Typography';
import { dateDiffToString, formatDate, formatPeriodeString, formatDayString, formatNumber, getDatesBetweenTowDates, getMonthBetweenTowMonth, } from '../../services/utils/utils';
import { EditionAffaire } from '../affaire/EditionAffaire';
import { EditionActivite } from '../activite/EditionActivite';
import { FONT_SIZE } from '../../theme';
import { CardTitle } from '../../utils/CardTitle';
import { Link } from '../../utils/Link';
import { FiltreStatistique } from '../statistique/FiltreStatistique';
import { getParamsKanban, updateParamsKanban } from '../../services/filtre';
var TYPE_DATE = 'date';
var TYPE_SIGNATURE = 'signature';
var TYPE_ETAPE = 'etape';
export var Kanban = function () {
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var defaultType = [TYPE_SIGNATURE, TYPE_DATE, TYPE_ETAPE].includes(window.location.hash.replace('#', ''))
        ? window.location.hash.replace('#', '')
        : TYPE_DATE;
    var _b = useState(getParamsKanban(defaultType)), search = _b[0], setSearch = _b[1];
    var _c = useState([]), events = _c[0], setEvents = _c[1];
    var _d = useState({ etapes: [], clients: [] }), utils = _d[0], setUtils = _d[1];
    var _e = useState(null), eventSelected = _e[0], setEventSelected = _e[1];
    var _f = useState(defaultType), type = _f[0], setType = _f[1];
    var _g = useState(null), clientSelected = _g[0], setClientSelected = _g[1];
    var columns = [];
    switch (type) {
        case TYPE_DATE: {
            columns = getDatesBetweenTowDates(search.Debut, search.Fin).map(function (date) {
                var dateFormated = formatDate(date);
                return {
                    value: date,
                    title: formatDayString(date),
                    color: dateFormated === formatDate(new Date()) ? 'primary' : 'header',
                    filter: function (event) {
                        return formatDate(event.DateDebut ? event.DateDebut : new Date()) <=
                            dateFormated &&
                            formatDate(event.DateFin ? event.DateFin : new Date()) >=
                                dateFormated;
                    },
                    content: function (event) {
                        return event.IsActivite ? (_jsx(Stack, __assign({ alignItems: "end" }, { children: _jsx(Typography, __assign({ variant: "body2", sx: {
                                    fontStyle: 'italic',
                                    fontSize: FONT_SIZE.SMALL,
                                } }, { children: "\u00C0 ".concat(new Date(event.DateDebut)
                                    .toLocaleTimeString([], {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                })
                                    .replace(':', 'h'), " pendant ").concat(dateDiffToString(event.DateDebut, event.DateFin)) })) }))) : !event.DateDebut ||
                            !event.DateFin ||
                            formatDate(event.DateDebut) !== formatDate(event.DateFin) ? (_jsx(Stack, __assign({ alignItems: "end" }, { children: _jsx(Typography, __assign({ variant: "body2", sx: {
                                    fontStyle: 'italic',
                                    fontSize: FONT_SIZE.SMALL,
                                    color: !event.DateDebut || !event.DateFin ? 'error.main' : '',
                                } }, { children: formatPeriodeString(event.DateDebut, event.DateFin) })) }))) : null;
                    },
                };
            });
            break;
        }
        case TYPE_SIGNATURE: {
            columns = getMonthBetweenTowMonth(search.Debut, search.Fin).map(function (month) {
                return {
                    value: month,
                    title: converYearMonthToString(month),
                    color: month === convertDateToYearMonth(new Date())
                        ? 'primary'
                        : 'header',
                    filter: function (event) { return event.MoisSignature === month; },
                    content: function (event) { return (_jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between" }, { children: [_jsx(Typography, __assign({ variant: "body2", sx: {
                                    fontStyle: 'italic',
                                    fontSize: FONT_SIZE.SMALL,
                                } }, { children: formatNumber(event.Tarif, '€') })), _jsx(Typography, __assign({ variant: "body2", sx: {
                                    fontStyle: 'italic',
                                    fontSize: FONT_SIZE.SMALL,
                                } }, { children: event.EtapeLibelle }))] }))); },
                };
            });
            break;
        }
        case TYPE_ETAPE: {
            columns =
                utils && utils.etapes
                    ? utils.etapes.map(function (etape) {
                        return {
                            value: etape.Id.toString(),
                            title: etape.Libelle,
                            color: colorEtatAffaire(etape.GoCloture ? 'C' : 'E'),
                            filter: function (event) { return event.Etape === etape.Id.toString(); },
                            content: function (event) { return (_jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between" }, { children: [_jsx(Typography, __assign({ variant: "body2", sx: {
                                            fontStyle: 'italic',
                                            fontSize: FONT_SIZE.SMALL,
                                        } }, { children: formatNumber(event.Tarif, '€') })), _jsx(Typography, __assign({ variant: "body2", sx: {
                                            fontStyle: 'italic',
                                            fontSize: FONT_SIZE.SMALL,
                                        } }, { children: converYearMonthToString(event.MoisSignature) }))] }))); },
                        };
                    })
                    : [];
            break;
        }
    }
    useEffect(function () {
        var getDatas = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, newEvents, newUtils, clients, _i, newEvents_1, event_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getKanban(type, search)];
                    case 1:
                        _a = _b.sent(), newEvents = _a.events, newUtils = _a.utils;
                        clients = {};
                        for (_i = 0, newEvents_1 = newEvents; _i < newEvents_1.length; _i++) {
                            event_1 = newEvents_1[_i];
                            clients[event_1.ClientId] = event_1.Client;
                        }
                        setEvents(newEvents);
                        setUtils({
                            etapes: newUtils && newUtils.etapes ? newUtils.etapes : null,
                            clients: Object.entries(clients).map(function (_a) {
                                var value = _a[0], label = _a[1];
                                return ({
                                    value: value,
                                    label: label,
                                });
                            }),
                        });
                        setClientSelected(null);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (!eventSelected) {
            getDatas();
        }
    }, [eventSelected, search, type]);
    var savePeriode = function (newSearch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            updateParamsKanban(type, newSearch);
            setSearch(newSearch);
            return [2 /*return*/];
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 1 }, { children: [_jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(CardTitle, { title: "Kanban", startIcon: _jsx(KanbanIcon, {}), color: "neutre", withFileAriane: true }), _jsx(FiltreStatistique, { handeOnSearch: savePeriode, Search: search, useSliderMonth: [TYPE_SIGNATURE, TYPE_ETAPE].includes(type), minDiff: type === TYPE_DATE ? 4 : null, maxDiff: type === TYPE_SIGNATURE ? 5 : type === TYPE_DATE ? 6 : null }, type)] })), _jsxs(Stack, __assign({ className: "w-full" }, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 2, justifyContent: "space-between" }, { children: [_jsxs(RadioGroup, __assign({ row: true, value: type, onChange: function (e, newValue) {
                                            window.location.hash = newValue;
                                            setLoading(true);
                                            setType(newValue);
                                            setSearch(getParamsKanban(newValue));
                                        } }, { children: [_jsx(FormControlLabel, { value: TYPE_DATE, control: _jsx(Radio, {}), label: "Par date" }), _jsx(FormControlLabel, { value: TYPE_SIGNATURE, control: _jsx(Radio, {}), label: "Par mois de signature" }), _jsx(FormControlLabel, { value: TYPE_ETAPE, control: _jsx(Radio, {}), label: "Par \u00E9tape" })] })), _jsx(Autocomplete, { className: "pb-xsmall", options: utils.clients, sx: { width: 300 }, value: clientSelected, onChange: function (e, value) {
                                            setClientSelected(value);
                                        }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: "standard", label: "Client" }))); } })] })), _jsx(Grid, __assign({ container: true, spacing: 1, columns: columns.length }, { children: loading ? (_jsx(Grid, __assign({ item: true, xs: columns.length }, { children: _jsx(Loader, {}) }))) : (_jsx(_Fragment, { children: columns.map(function (column) {
                                        var eventsInColumn = events.filter(function (event) {
                                            return column.filter(event) &&
                                                (clientSelected === null ||
                                                    event.ClientId === parseInt(clientSelected.value));
                                        });
                                        var tarifTotal = formatNumber(eventsInColumn.reduce(function (acc, event) { return (acc += event.Tarif); }, 0), '€', 0);
                                        return (_jsxs(Grid, __assign({ item: true, xs: 1 }, { children: [_jsx(CardTitle, { title: column.title, color: column.color, renderButtons: function () { return (_jsx(Typography, __assign({ sx: __assign(__assign({}, classTotal('header')), { borderWidth: '1px' }), className: "mb-medium", color: "header.main", variant: "body2" }, { children: formatNumber(eventsInColumn.length) }))); }, renderInfos: [TYPE_ETAPE, TYPE_SIGNATURE].includes(type)
                                                        ? function () { return (_jsx(_Fragment, { children: _jsx(Stack, __assign({ paddingX: 1, direction: "row", sx: {
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    bottom: 0,
                                                                }, justifyContent: "end" }, { children: _jsx(Typography, __assign({ color: "white.main", variant: "body2" }, { children: tarifTotal })) })) })); }
                                                        : null }), _jsx(Stack, __assign({ spacing: 1 }, { children: eventsInColumn.map(function (event) {
                                                        return (_jsx(Card, __assign({ className: "relative", sx: {
                                                                boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.3)',
                                                                padding: 1,
                                                                borderLeftWidth: 4,
                                                                borderLeftStyle: 'solid',
                                                                borderLeftColor: "".concat(event.IsActivite
                                                                    ? colorEtatActivite(event.Etat)
                                                                    : colorEtatAffaire(event.Etat), ".main"),
                                                            } }, { children: _jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(Link, { title: event.Client, color: "client", to: "/client/fiche/".concat(event.ClientId), icon: _jsx(ClientIcon, { fontSize: "small" }) }), _jsx(Link, { title: event.Libelle, color: event.IsActivite ? 'activite' : 'affaire', to: event.IsActivite
                                                                            ? '/'
                                                                            : "/affaire/fiche/".concat(event.Id), onClick: event.IsActivite
                                                                            ? function (e) {
                                                                                e.preventDefault();
                                                                                setEventSelected(event);
                                                                            }
                                                                            : null, icon: event.IsActivite ? (_jsx(ActiviteIcon, { fontSize: "small" })) : (_jsx(AffaireIcon, { fontSize: "small" })), bold: true }), column.content && column.content(event)] })) }), "".concat(event.IsActivite, "-").concat(event.Id)));
                                                    }) }))] }), column.title));
                                    }) })) }))] }))] })), eventSelected && eventSelected.IsActivite && (_jsx(EditionActivite, { ActiviteId: eventSelected.Id, ClientId: eventSelected.ClientId, handleClose: function () {
                    setEventSelected(null);
                } })), eventSelected && !eventSelected.IsActivite && (_jsx(EditionAffaire, { AffaireId: eventSelected.Id, ClientId: eventSelected.ClientId, handleClose: function () {
                    setEventSelected(null);
                } }))] }));
};
//# sourceMappingURL=Kanban.js.map